import React, { Children } from 'react';
import { useSetState } from 'utils/functions.utils';
import './stepper.component.scss';
import { Assets } from '../../utils/imports.utils';
import { Stepper } from 'react-form-stepper';

interface StepperProps {
  status?: string;
}

const StepperComponent = (props: StepperProps) => {
  return (
    <div className="stepper_details_order_status_container">
      <div className="details_order_status_wrapper">
        <div className="details_order_status_element">
          <div className="details_checkbox_container">
            <img
              src={
                props.status === 'PICKED UP' ||
                props.status === 'PROCESSING' ||
                props.status === 'DISPATCH' ||
                props.status === 'REACHED'||
                props.status === 'DELIVERED'
                  ? Assets.status_active
                  : Assets.disable_status
              }
              className="status_active"
            />
            <div
              className={`${
                props.status === 'PICKED UP' ||
                props.status === 'PROCESSING' ||
                props.status === 'DISPATCH' ||
                props.status === 'REACHED'||
                props.status === 'DELIVERED'
                  ? 'details_dashed_line'
                  : 'details_disable_line'
              }`}
            />
          </div>
          <div className="details_order_status_text">Picked up</div>
        </div>

        <div className="details_order_status_element">
          <div className="details_checkbox_container">
            <img
              src={
                props.status === 'DISPATCH' || props.status === 'DELIVERED'
                  ? Assets.status_active
                  : Assets.disable_status
              }
              className="status_active"
            />
            <div
              className={`${
                props.status === 'DISPATCH' || props.status === 'DELIVERED'
                  ? 'details_dashed_line'
                  : 'details_disable_line'
              }`}
            />
          </div>
          <div className="details_order_status_text">Dispatched</div>
        </div>
        <div className="details_order_status_element">
          <div className="details_checkbox_container">
            <img
              src={
                props.status === 'DELIVERED'
                  ? Assets.status_active
                  : Assets.disable_status
              }
              className="status_active"
            />
          </div>
          <div className="details_order_status_text">Delivered</div>
        </div>
      </div>
    </div>
  );
};

export default StepperComponent;
